import React from "react";

import ProjectIcon from '../../../../../../core/gd-ui/project-icon/project-icon-ui5';
import ProjectPathProperty from "../../../../../../core/gd-ui/project-path/project-path-property";

import Classes from "classnames";

type Props = {
    project    : any
    isSelected : boolean
    onClick    : callback
}
export default class SearchProjectOption extends React.Component<Props> {
    onClick = () => {
        if (this.props.onClick) this.props.onClick(this.props.project.id);
    }
    render() {
        const classes = Classes("row", "ui5-list-item", {
            'selected': this.props.isSelected,
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="cell">
                    <div className="title">
                        <div className="icon-22 m-r-10">
                            <ProjectIcon projectId={this.props.project.id} size="16" hint={false} colorize={true}/>
                        </div>
                        <div className="ui5-txt-default max-w-250">{this.props.project.name}</div>
                    </div>
                </div>
                <div className="cell align-r">
                    <ProjectPathProperty className="max-w-200" projectId={this.props.project.id} showEmptyRoot={true} maxFirstParents={2} showParentsOnly={true}/>
                </div>
            </div>
        )

    }
}
